import { styled } from '@mui/material/styles';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@monorepo/nova-ui';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    margin: theme.spacing(6),
  },
  [theme.breakpoints.up('md')]: {
    margin: theme.spacing(8),
  },
  '& .MuiDialog-paper': {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(10),
    width: theme.spacing(150),
    margin: 0,
    maxWidth: '100%',
    overflowX: 'hidden',
  },
}));

export const StyledDialogTitle = styled(DialogTitle)({
  padding: 0,
  margin: 0,
});

export const StyledDialogContent = styled(DialogContent)({
  padding: 0,
  margin: 0,
  overflowX: 'hidden',
  maxWidth: '100%',
});

export const StyledTitleRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  [theme.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
}));

export const StyledTitleTypography = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flex: 1,
    minWidth: 0,
    maxWidth: 150,
  },
}));
